import React from "react";
import styles from "./styles/Home.module.css";
import Carrusel from "./component/Carrusel";
import CarruselUser from "./component/CarruselUser";
import {Link} from 'react-router-dom';
import { useState, useEffect } from "react";
import $ from "jquery";    


const HomeTutor = () => {

    const [usuario] = useState(() => {
            const usuarioAlmacenado = localStorage.getItem("userLogueado");
            return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : {};
    })

    useEffect(() => {
        $("#welcome-title")
        .hide()
        .fadeIn(800);

        return () => {
            $("#welcome-title").stop(true, true).show();
        };
    }, []);

    return(
        <>

        <div name="Home" className={styles.home}> 
            <h2 id="welcome-title" style={{ width: '100%', textAlign: 'left', paddingLeft: 20 }}>Bienvenido, {usuario.Usuario}</h2>
            <div className={styles.titleConteiner}>
                <div className={styles.tutorContainer}>
                    <button className={styles.botonTutor}><Link to="/subirContenido" style={{color: 'var(--textButtonHome)'}}>Subir contenido</Link></button>
                    <button className={styles.botonTutor}><Link to="/listarContenido" style={{color: 'var(--textButtonHome)'}}>Ver mi contenido</Link></button>
                </div>
                
            </div>
        </div>
            <Carrusel />
            <CarruselUser />

        </>
        
    );
};

export default HomeTutor;